'use strict';

var _regeneratorRuntime = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _asyncIterator = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncIterator");

var normaliseInput = require('ipfs-core-utils/src/files/normalise-input');

var modeToString = require('./mode-to-string');

var mtimeToObject = require('./mtime-to-object');

var _require = require('ipfs-utils/src/globalthis'),
    File = _require.File,
    FormData = _require.FormData;

function multipartRequest() {
  return _multipartRequest.apply(this, arguments);
}

function _multipartRequest() {
  _multipartRequest = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var source,
        abortController,
        headers,
        formData,
        index,
        _iteratorNormalCompletion,
        _didIteratorError,
        _iteratorError,
        _iterator,
        _step,
        _value,
        _value2,
        content,
        path,
        mode,
        mtime,
        fileSuffix,
        type,
        fieldName,
        qs,
        _mtimeToObject,
        secs,
        nsecs,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            source = _args.length > 0 && _args[0] !== undefined ? _args[0] : '';
            abortController = _args.length > 1 ? _args[1] : undefined;
            headers = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
            formData = new FormData();
            index = 0;
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context.prev = 7;
            _iterator = _asyncIterator(normaliseInput(source));

          case 9:
            _context.next = 11;
            return _iterator.next();

          case 11:
            _step = _context.sent;
            _iteratorNormalCompletion = _step.done;
            _context.next = 15;
            return _step.value;

          case 15:
            _value = _context.sent;

            if (_iteratorNormalCompletion) {
              _context.next = 31;
              break;
            }

            _value2 = _value, content = _value2.content, path = _value2.path, mode = _value2.mode, mtime = _value2.mtime;
            fileSuffix = '';
            type = content ? 'file' : 'dir';

            if (index > 0) {
              fileSuffix = "-".concat(index);
            }

            fieldName = type + fileSuffix;
            qs = [];

            if (mode !== null && mode !== undefined) {
              qs.push("mode=".concat(modeToString(mode)));
            }

            if (mtime != null) {
              _mtimeToObject = mtimeToObject(mtime), secs = _mtimeToObject.secs, nsecs = _mtimeToObject.nsecs;
              qs.push("mtime=".concat(secs));

              if (nsecs != null) {
                qs.push("mtime-nsecs=".concat(nsecs));
              }
            }

            if (qs.length) {
              fieldName = "".concat(fieldName, "?").concat(qs.join('&'));
            }

            if (content) {
              formData.set(fieldName, content, encodeURIComponent(path));
            } else {
              formData.set(fieldName, new File([''], encodeURIComponent(path), {
                type: 'application/x-directory'
              }));
            }

            index++;

          case 28:
            _iteratorNormalCompletion = true;
            _context.next = 9;
            break;

          case 31:
            _context.next = 37;
            break;

          case 33:
            _context.prev = 33;
            _context.t0 = _context["catch"](7);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 37:
            _context.prev = 37;
            _context.prev = 38;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context.next = 42;
              break;
            }

            _context.next = 42;
            return _iterator.return();

          case 42:
            _context.prev = 42;

            if (!_didIteratorError) {
              _context.next = 45;
              break;
            }

            throw _iteratorError;

          case 45:
            return _context.finish(42);

          case 46:
            return _context.finish(37);

          case 47:
            return _context.abrupt("return", {
              headers: headers,
              body: formData
            });

          case 48:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[7, 33, 37, 47], [38,, 42, 46]]);
  }));
  return _multipartRequest.apply(this, arguments);
}

module.exports = multipartRequest;